import React from 'react'
import { withStyles } from 'material-ui/styles'
import { highlightCurrencies } from 'actions/dashboard'
import Amount from 'components/Amount'
import Typography from 'material-ui/Typography'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import compose from 'recompose/compose'
import { capitalize } from 'lodash'
import Bar from 'components/Bar'
import green from 'material-ui/colors/green'
import Button from 'components/Button'
import red from 'material-ui/colors/red'
import Grid from 'material-ui/Grid'
import Tooltip from 'material-ui/Tooltip'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import UpIcon from 'material-ui-icons/CallMade'
import DownIcon from 'material-ui-icons/CallReceived'
const styles = theme => ({
  root: {},
  totalHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  totalbalance: {
    fontSize: 40,
  },
  total: {
    marginBottom: theme.spacing.unit * 4,
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.default,
    zIndex: 1,
    margin: -15,
    padding: 15,
  },
  totalTitle: {
    flexGrow: 1,
    alignSelf: 'center',
  },
  fundsTitle: {
    marginBottom: theme.spacing.unit * 2,
  },
  addFundButton: {
    minWidth: 'auto',
  },
  fund: {
    [theme.breakpoints.up('md')]: {
      padding: '6px 40px 4px 0',
      margin: '6px -40px 0px 0',
      borderRadius: '10px 0 0 10px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '6px 15px',
      margin: '6px -15px',
    },
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create(
      ['background-color', 'padding', 'margin'],
      {
        duration: theme.transitions.duration.standard,
      }
    ),
    '&:hover, &$fundSelected': {
      [theme.breakpoints.up('md')]: {
        paddingLeft: 25,
        marginLeft: -25,
      },
      backgroundColor: theme.palette.text.secondary,
      fontWeight: 700,
      color: theme.palette.getContrastText(theme.palette.text.secondary),
      '& $fundSelectedTypography, & $fundSelectedTypography span': {
        color: theme.palette.getContrastText(theme.palette.text.secondary),
        fontWeight: 700,
      },
    },
  },
  fundSelected: {},
  header: {
    display: 'flex',
    marginBottom: 4,
  },
  amount: {
    flexGrow: 1,
    textAlign: 'right',
  },
  fundSelectedTypography: {
    '& span': {
      color: theme.palette.text.secondary,
    },
  },
  secondary: {
    color: theme.palette.text.secondary,
  },
})

class FundsTable extends React.Component {
  getIcon = currency => {
    const style = {
      width: 16,
      height: 16,
      marginLeft: 10,
    }
    if (this.props.ticker.btc[currency].trend < 0) {
      return <DownIcon color={red[500]} style={style} />
    } else {
      return <UpIcon color={green[500]} style={style} />
    }
  }
  render() {
    const {
      funds,
      cryptocurrencies,
      classes,
      colour,
      highlightedCurrencies,
      highlightCurrencies,
      totalbalance,
    } = this.props
    return (
      <div className={classes.root}>
        <div className={classes.total}>
          <div className={classes.totalHeader}>
            <Typography type="button" className={classes.totalTitle}>
              Total
            </Typography>
            <Amount
              value={totalbalance}
              className={classes.totalbalance}
              mainCurrency
            />
          </div>
          <Bar total big colour={colour} />
        </div>
        <Typography type="button" className={classes.fundsTitle}>
          Funds{' '}
          <Tooltip title="Add a fund to the list" placement="right">
            <Button
              className={classes.addFundButton}
              component={Link}
              to="/funds"
            >
              +
            </Button>
          </Tooltip>
        </Typography>
        {funds.map(fund => (
          <div
            className={classNames(classes.fund, {
              [classes.fundSelected]:
                highlightedCurrencies.indexOf(fund.currency) > -1,
            })}
            key={fund._uid}
            onMouseEnter={() => highlightCurrencies([fund.currency])}
            onMouseLeave={() => highlightCurrencies([])}
          >
            <div className={classes.header}>
              <Typography className={classes.fundSelectedTypography}>
                {capitalize(cryptocurrencies[fund.currency])}
                {fund.type === 'hash' && <span> Address</span>}
                <span> {fund.description}</span>
              </Typography>
              <div className={classes.amount}>
                <Amount value={fund.value} mainCurrency />
                {this.getIcon(fund.currency)}
              </div>
            </div>
            <Bar fund={fund} colour={colour} />
            <Grid item xs={6} sm={7} />
          </div>
        ))}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  funds: selectors.fundsWithValue(state),
  highlightedCurrencies: selectors.highlightedCurrencies(state),
  ticker: selectors.ticker(state),
  cryptocurrencies: selectors.cryptocurrencies(state),
  totalbalance: selectors.totalbalance(state),
})
const mapDispatchToProps = dispatch => ({
  highlightCurrencies: f => dispatch(highlightCurrencies(f)),
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(FundsTable)



// WEBPACK FOOTER //
// ./src/components/FundsTable.js